'use client'

import _ from 'lodash'
import { useState, useEffect } from 'react'
import { ListBox, Text } from '@/components'
import { lookup } from '@cruz-com/lookup'
import { radiusOption } from '@/settings'

type DefaultQuery = {
  zip_code?: string
  radius?: number
  sort_id?: number
}

type Props = {
  defaultQuery: DefaultQuery
  onSortIdChanged: (val: any) => void
  onLocationChanged: (val: any) => void
}

export function VehicleFilter2({ defaultQuery, onSortIdChanged, onLocationChanged }: Props) {
  const [loc, setLoc] = useState<any>(_.pick(defaultQuery, ['zip_code', 'radius']))

  useEffect(() => {
    setLoc(_.pick(defaultQuery, ['zip_code', 'radius']))
  }, [defaultQuery?.zip_code, defaultQuery?.radius])

  function locChanged(name: string, value: any) {
    let updateValue = value
    if (name === 'zip_code') {
      updateValue = value.replace(/\D/g, '') // Remove all non-digit characters
    }
    const d = { ...loc, [name]: updateValue }
    setLoc(d)
    const zLen = _.size(d.zip_code)
    if (zLen === 5 || (zLen === 0 && _.size(loc.zip_code) > 0)) {
      if (d.radius > 0 || (d.radius < 0 && loc.radius > 0)) {
        onLocationChanged(d)
      }
    }
  }

  function sortIdChanged(value: any) {
    onSortIdChanged(value)
  }

  return (
    <div className='vehicle-s2-filter'>
      <div className='flex gap-x-4'>
        <div className='flex items-center'>
          <label htmlFor='zip_code_2' className='vehicle-s2-label mr-2'>Zip Code:</label>
          <div className='w-[75px]'>
            <Text inline={true} compact={true} name='zip_code' id='zip_code_2' maxLength={5} type='tel'
              value={loc?.zip_code || ''}
              onChange={e => locChanged('zip_code', e.target.value)}
              onFocus={e => e.target.select()}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <div className='vehicle-s2-label mr-2'>Radius:</div>
          <div className='w-[130px]'>
            <ListBox inline={true} compact={true}
              option={radiusOption}
              value={loc?.radius || -1}
              onChange={(val) => { locChanged('radius', val) }}
            />
          </div>
        </div>
      </div>
      <div className='flex items-center gap-x-3'>
        <div className='vehicle-s2-label'>Sort By:</div>
        <ListBox inline className='min-w-[200px]'
          option={lookup.vehicle.sortOption}
          value={_.toNumber(defaultQuery?.sort_id || 1)}
          onChange={val => { sortIdChanged(val) }}
        />
      </div>
    </div>
  )
}